import { useEffect, useRef, useState } from 'react';
import { Lock } from 'lucide-react';
import useBoardStore from '../../store/boardStore';
import useAuthStore from '../../store/authStore';

// Pedido de senha na abertura de um quadro protegido.
//
// Montado pela BoardView NO LUGAR do conteudo (acima de BoardTable, nunca
// dentro dela): a tabela nem e renderizada enquanto esta tela esta no ar.
//
// TEXTO DA INTERFACE: fala do comportamento — "este quadro pede senha para
// abrir" —, nunca de protecao de dados. A conferencia e do servidor (POST
// /boards/:id/unlock); a senha digitada nao e guardada em lugar nenhum, e o
// que sobrevive e so "este quadro ja foi desbloqueado nesta aba"
// (utils/boardUnlock.js).
//
// Todos digitam, inclusive quem cadastrou a senha — decisao do dono.

export default function BoardUnlockGate({ board, onUnlocked }) {
  const unlockBoard = useBoardStore((s) => s.unlockBoard);
  const user = useAuthStore((s) => s.user);
  const [password, setPassword] = useState('');
  const [checking, setChecking] = useState(false);
  const [error, setError] = useState(null);
  const inputRef = useRef(null);

  useEffect(() => { inputRef.current?.focus(); }, [board?.id]);

  const submit = async (e) => {
    e?.preventDefault();
    if (checking || password === '') return;
    setError(null);
    setChecking(true);
    try {
      // A marca guardada e "este usuario desbloqueou ESTA geracao da senha":
      // trocar a senha, ou trocar de usuario na mesma aba, invalida.
      await unlockBoard(board.id, password, {
        userId: user?.id,
        version: board.protection_version,
      });
      setPassword('');
      onUnlocked();
    } catch (err) {
      // 401 = senha errada (o servidor ja registrou a tentativa na
      // auditoria). Qualquer outro status mostra a mensagem do servidor.
      setError(err.status === 401 ? 'Senha incorreta.' : (err.message || 'Não foi possível verificar a senha.'));
      setPassword('');
      inputRef.current?.focus();
    } finally {
      setChecking(false);
    }
  };

  return (
    <div className="h-full flex items-center justify-center p-8">
      <form onSubmit={submit} className="w-full max-w-sm text-center">
        <div className="w-14 h-14 rounded-full bg-accent/10 flex items-center justify-center mx-auto mb-4">
          <Lock className="w-7 h-7 text-accent" />
        </div>
        <h2 className="text-lg font-semibold text-text-primary mb-1">
          {board?.name}
        </h2>
        <p className="text-sm text-text-secondary mb-5">
          Este quadro pede uma senha para abrir.
        </p>

        <input
          ref={inputRef}
          type="password"
          autoComplete="off"
          value={password}
          onChange={(e) => { setPassword(e.target.value); setError(null); }}
          placeholder="Senha do quadro"
          disabled={checking}
          className="w-full bg-main border border-border rounded px-3 py-2 text-sm text-text-primary placeholder-text-secondary/50 outline-none focus:border-accent/50 text-center disabled:opacity-60"
        />

        {error && (
          <p className="mt-2 text-xs text-danger">{error}</p>
        )}

        <button
          type="submit"
          disabled={checking || password === ''}
          className="mt-4 w-full px-4 py-2 rounded-md bg-accent text-white text-sm font-medium hover:bg-accent/80 transition-colors disabled:opacity-50"
        >
          {checking ? 'Verificando...' : 'Abrir quadro'}
        </button>

        <p className="mt-4 text-[11px] text-text-secondary/70 leading-relaxed">
          Não sabe a senha? Peça a quem administra este quadro.
        </p>
      </form>
    </div>
  );
}
